import React, { createContext, useContext } from 'react';
import { node, bool, string } from 'prop-types';

const PresentationContext = createContext({});
export const usePresentation = () => useContext(PresentationContext);

export const PresentationProvider = ({ useCondensedLayout, itemId, showProductAttribution, children }) => {
  return (
    <PresentationContext.Provider value={{ useCondensedLayout, itemId, showProductAttribution }}>
      { children }
    </PresentationContext.Provider>
  );
};

PresentationProvider.propTypes = {
  children: node.isRequired,
  useCondensedLayout: bool.isRequired,
  itemId: string,
  showProductAttribution: bool
};

PresentationProvider.defaultProps = {
  itemId: null,
  showProductAttribution: false
};
